import styled, { css } from "styled-components";

import { outerContainerCss as parantOuterContainerCss } from "../../constants/styles";
import { narrowScreenMediaQuery } from "../../constants/global-style";

export {
  assets_cyanish,
  black,
  bluish,
  bright_black,
  cyanish,
  danger_red,
  dark_yellow,
  darker_blue,
  darker_grayish,
  faint_grayish,
  faint_purplish,
  gray_footer_text,
  grayish,
  greenish,
  light_gray,
  light_yellow,
  off_black,
  off_white,
  orangish,
  ppip_purple,
  ppip_yellow,
  purplish,
  referrer_color,
  shaded_gray,
  statement_green,
  statement_red,
  taxsam_yellow_navbar,
  white,
} from "../../constants/styles";

export const outerContainerCss = css`
  ${parantOuterContainerCss};
  padding-left: 0;
  padding-right: 0;

  @media ${narrowScreenMediaQuery} {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const BackgroundTheme = styled.div`
  background-color: var(--background);
`;

// Page Layout Components - Twitter/X-like 3-column layout
export const AppLayout = styled.div`
  ${outerContainerCss};
  display: flex;
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
`;

export const MainArea = styled.div`
  flex: 1;
  display: flex;
  min-width: 0;
  min-height: 100vh;
  overflow: hidden;
`;

export const FeedColumn = styled.main`
  flex: 1;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 100vh;
  border-left: 1px solid var(--border);
  border-right: 1px solid var(--border);
  scrollbar-width: thin;

  @media (max-width: 719px) {
    max-width: 100%;
    border-left: none;
    border-right: none;
  }
`;

export const RightSidebar = styled.aside`
  width: 350px;
  min-width: 280px;
  flex-shrink: 1;
  padding: 0 1rem;
  display: none;
  position: sticky;
  top: 0;
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;

  @media (min-width: 1080px) {
    display: block;
  }
`;

// Mobile Header
export const MobileHeader = styled.header`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: var(--card);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 50;

  @media (min-width: 720px) {
    display: none;
  }
`;

export const MobileMenuButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export const MobileAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary), #ffb347);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  span {
    font-weight: 700;
    color: white;
    font-size: 0.75rem;
  }
`;

export const MobileTitle = styled.h1`
  flex: 1;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--foreground);
`;

// Feed Tabs
export const FeedTabs = styled.div`
  display: flex;
  border-bottom: 1px solid var(--border);
  background: var(--card);
  position: sticky;
  top: 0;
  z-index: 40;

  @media (max-width: 719px) {
    top: 57px;
  }
`;

export const FeedTab = styled.button`
  flex: 1;
  padding: 1rem;
  background: transparent;
  border: none;
  font-size: 0.9375rem;
  font-weight: ${(props) => (props.$active ? "700" : "500")};
  color: ${(props) =>
    props.$active ? "var(--foreground)" : "var(--muted-foreground)"};
  cursor: pointer;
  position: relative;
  transition: all 0.2s;

  &:hover {
    background: var(--secondary);
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: ${(props) => (props.$active ? "56px" : "0")};
    height: 4px;
    background: var(--primary);
    border-radius: 9999px;
    transition: width 0.2s;
  }
`;

// Compose Box
export const ComposeBox = styled.div`
  display: flex;
  gap: 0.75rem;
  padding: 1rem;
  border-bottom: 1px solid var(--border);
  background: var(--card);
`;

export const ComposeAvatar = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary), #ffb347);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  span {
    font-weight: 700;
    color: white;
    font-size: 0.875rem;
  }
`;

export const ComposeContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ComposeInput = styled.div`
  min-height: 50px;
  font-size: 1.25rem;
  color: var(--muted-foreground);
  padding: 0.5rem 0;
  cursor: pointer;

  &:hover {
    color: var(--muted-foreground);
  }
`;

export const ComposeActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid var(--border);
`;

export const ComposeTools = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const ComposeTool = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: transparent;
  border: none;
  color: var(--primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: rgba(var(--primary-rgb), 0.1);
  }
`;

export const ComposeButton = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  background: var(--primary);
  color: white;
  font-weight: 700;
  font-size: 0.9375rem;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Legacy exports for backward compatibility
export const PageWrapper = styled.div`
  min-height: 100vh;
  background-color: var(--background);
`;

export const HeadersContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
`;

export const PrimaryHeaderWrapper = styled.div`
  transition: all 0.3s ease;
  max-height: ${(props) => (props.$show ? "200px" : "0")};
  overflow: hidden;
  opacity: ${(props) => (props.$show ? "1" : "0")};
`;

export const MainContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  gap: 1.5rem;
  padding: 1.5rem 1rem;

  @media (min-width: 720px) {
    padding: 2rem 1.5rem;
  }
`;

export const MainContent = styled.main`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-bottom: 5rem;

  @media (min-width: 720px) {
    padding-bottom: 0;
  }
`;

export const TrendingAside = styled.aside`
  width: 340px;
  flex-shrink: 0;
  display: none;

  @media (min-width: 720px) {
    display: block;
  }
`;

// Card Components
export const Card = styled.div`
  background: var(--card);
  border-radius: 0.75rem;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border);
`;

export const CardTitle = styled.h2`
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--foreground);
`;

// Avatar Components
export const Avatar = styled.div`
  width: ${(props) => props.$size || "3rem"};
  height: ${(props) => props.$size || "3rem"};
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary), #ffb347);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  span {
    font-size: ${(props) => props.$fontSize || "0.875rem"};
    font-weight: 700;
    color: white;
  }
`;

// Button Components
export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.$size || "2rem"};
  height: ${(props) => props.$size || "2rem"};
  padding: 0;
  border-radius: 50%;
  background: transparent;
  border: none;
  color: var(--muted);
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: var(--secondary);
    color: var(--foreground);
  }
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: 9999px;
  background: transparent;
  border: none;
  color: ${(props) =>
    props.$isActive
      ? props.$activeColor || "var(--primary)"
      : "var(--muted-foreground)"};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    color: var(--primary);
    background: rgba(var(--primary-rgb), 0.1);
  }

  svg {
    color: ${(props) =>
      props.$isActive ? props.$activeColor || "var(--primary)" : "inherit"};
  }

  span {
    font-size: 0.75rem;
  }
`;

export const PrimaryButton = styled.button`
  padding: 0.5rem 1.5rem;
  background: var(--primary);
  color: var(--primary-foreground);
  font-weight: 600;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Badge Components
export const RoleBadge = styled.span`
  font-size: 0.75rem;
  background: var(--accent);
  color: var(--primary);
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
  font-weight: 500;
`;

export { narrowScreenMediaQuery };
